export function initializeSplideJS() {
  const splides = document.querySelectorAll('[data-action="splidejs"]');
  if (splides.length < 1) return;

  import('@splidejs/splide')
    .then(({ default: Splide }) => {
      splides.forEach(element => new Splide(element as HTMLElement).mount());
    })
    .catch(err => console.error(err));
}
